
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 24 24","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#1976d2"}},[_c('path',{attrs:{"d":"M11.999 4.483l7.119 4.246L24 4.954 16.939.5zM12 4.485L7.06.5 0 4.953 4.883 8.73z"}}),_c('path',{attrs:{"d":"M12 12.976l4.939 3.983L24 12.506l-4.883-3.777L12 12.975 4.881 8.729 0 12.506l7.06 4.453z"}}),_c('path',{attrs:{"d":"M19.501 19.187v-2.125l-2.204 1.39v.001c-.828.527-1.205-.536-5.296-3.602-4.161 3.128-4.473 4.12-5.298 3.601l-2.202-1.389v2.124l7.515 4.313z"}})])])
          )
        }
      }
    